// src/hooks/useAuthorizedAccess.js

import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';

/**
 * Custom hook to check if current user has access to Employee List page
 * Checks the 'authorized_viewers' collection
 */
export const useAuthorizedAccess = () => {
  const { currentUser, userData } = useAuth();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      if (!currentUser) {
        setHasAccess(false);
        setLoading(false);
        return;
      }

      try {
        // Check if user exists in authorized_viewers collection
        const viewerRef = doc(db, 'authorized_viewers', currentUser.uid);
        const viewerSnap = await getDoc(viewerRef);

        setHasAccess(viewerSnap.exists());
      } catch (error) {
        console.error('Error checking authorized access:', error);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [currentUser]);

  return { hasAccess, loading };
};
